module.exports = __webpack_public_path__ + "src/assets/img/passion.f3cd128e.jpg";